// src/components/PrivacyPolicy.js
import React from "react";
import "../styles/privacy.css";

const PrivacyPolicy = ({ onBack }) => {
  return (
    <div className="privacy-policy">
      <div className="container privacy-container">
        <button className="privacy-back-btn" onClick={onBack}>
          ← Povratak na glavnu stranicu
        </button>
        
        <div className="privacy-content">
          <h1 className="privacy-title">Politika privatnosti</h1>
          
          <div className="privacy-section">
            <h2 className="privacy-section-title">1. Uvod</h2>
            <p className="privacy-text">
              KBIA poklon kutije ("mi", "nas", "naš") poštuje vašu privatnost i 
              obvezuje se zaštititi vaše osobne podatke. Ova politika privatnosti 
              objašnjava kako prikupljamo, koristimo i štitimo vaše osobne podatke 
              kada posjećujete našu web stranicu.
            </p>
          </div>

          <div className="privacy-section">
            <h2 className="privacy-section-title">2. Podaci koje prikupljamo</h2>
            <p className="privacy-text">
              Prikupljamo sljedeće vrste podataka:
            </p>
            <ul className="privacy-list">
              <li>Ime i kontakt informacije (kada nas kontaktirate putem kontakt forme)</li>
              <li>Informacije o posjećivanju web stranice (korištenje kolačića)</li>
              <li>Druge informacije koje nam dobrovoljno pružite</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2 className="privacy-section-title">3. Kako koristimo vaše podatke</h2>
            <p className="privacy-text">
              Vaše osobne podatke koristimo za:
            </p>
            <ul className="privacy-list">
              <li>Odgovaranje na vaše upite i zahtjeve</li>
              <li>Poboljšanje naših usluga i web stranice</li>
              <li>Komunikaciju s vama o našim proizvodima i uslugama</li>
              <li>Ispunjavanje zakonskih obveza</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2 className="privacy-section-title">4. Kolačići (Cookies)</h2>
            <p className="privacy-text">
              Naša web stranica koristi kolačiće za poboljšanje korisničkog iskustva. 
              Kolačići su male tekstualne datoteke koje se pohranjuju na vašem uređaju. 
              Možete kontrolirati kolačiće kroz postavke svog web preglednika.
            </p>
          </div>

          <div className="privacy-section">
            <h2 className="privacy-section-title">5. Zaštita podataka</h2>
            <p className="privacy-text">
              Primjenjujemo odgovarajuće tehničke i organizacijske mjere za zaštitu 
              vaših osobnih podataka od neovlaštenog pristupa, gubitka ili uništenja.
            </p>
          </div>

          <div className="privacy-section">
            <h2 className="privacy-section-title">6. Vaša prava</h2>
            <p className="privacy-text">
              Imate pravo:
            </p>
            <ul className="privacy-list">
              <li>Pristupa svojim osobnim podacima</li>
              <li>Ispravka netočnih podataka</li>
              <li>Brisanja vaših podataka</li>
              <li>Prigovora na obradu vaših podataka</li>
              <li>Prijenosa podataka</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2 className="privacy-section-title">7. Kontakt</h2>
            <p className="privacy-text">
              Ako imate pitanja o ovoj politici privatnosti ili želite ostvariti 
              svoja prava, kontaktirajte nas putem kontakt forme na našoj web stranici.
            </p>
          </div>

          <div className="privacy-section">
            <h2 className="privacy-section-title">8. Promjene politike privatnosti</h2>
            <p className="privacy-text">
              Zadržavamo pravo ažurirati ovu politiku privatnosti u bilo kojem trenutku. 
              Sve promjene će biti objavljene na ovoj stranici s datumom posljednje izmjene.
            </p>
            <p className="privacy-text privacy-updated">
              Posljednja izmjena: {new Date().toLocaleDateString("hr-HR")}
            </p>
          </div>

          <button className="privacy-back-btn-bottom" onClick={onBack}>
            ← Povratak na glavnu stranicu
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;













